import '../instrument.js';

import React, { useEffect } from 'react';
import { Switch, Route, Router, Redirect } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import socketIO from 'socket.io-client';

import PrivateLayout from './../components/Layouts/PrivateLayout';
import Models from './../components/Models/Models';
import MainContext from './../components/context/MainContext.jsx';
import Viewer from '../components/Viewer/Viewer';
import {
    getAllModels,
    handleModelDelete,
    handleModelTranslate,
} from './../actions/model';
import locale from './../utils/localization.json';
import NotFound from '../components/common/NotFound';
import PageRedirector from './../components/common/PageRedirector';
import { getAllPointClouds } from './../actions/pointcloud';
import { errorMessage } from '../utils/message.js';
import log from '../utils/log.js';

import * as Sentry from '@sentry/react';
// Create Custom Sentry Route component

import { createBrowserHistory } from 'history';
const history = createBrowserHistory();
const SentryRoute = Sentry.withSentryRouting(Route);

const Bimodel = () => {
    const currentObject = useSelector((state) => state.currentObject);
    const { permissions, category_id, project_id } = useSelector(
        (state) => state.currentProject
    );
    const lang = useSelector((state) => state.language);
    const token = useSelector((state) => state.token);

    const dispatch = useDispatch();

    useEffect(() => {
        const socket = socketIO(`${process.env.REACT_APP_OSS_SOCKET}`, {
            transports: ['websocket'],
        });
        socket.on('update', ({ _id, versions }) => {
            dispatch(handleModelTranslate(_id, versions));
        });
        socket.on('error', (message) => {
            if (message?.type === 'translate') {
                const { modelId, versionNumber, urn, errors } = message;

                dispatch(handleModelDelete(modelId, versionNumber, urn));

                errors?.forEach((err) => {
                    if (err) {
                        if (err.includes('corrupt'))
                            errorMessage(locale[lang].corruptedFile);
                        else if (err.includes('supported'))
                            errorMessage(locale[lang].notSupportedFile);
                        else log.error(err);
                    }
                });
            } else if (message?.type === 'analyze') {
                errorMessage(locale[lang].error);
                log.error(message?.detail);
            }
            dispatch(getAllModels());
            dispatch(getAllPointClouds());
        });
        socket.on('analyzed', () => {
            dispatch(getAllPointClouds());
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Router history={history}>
            <Switch>
                <SentryRoute path={['/project', '/viewer']}>
                    <MainContext>
                        <PrivateLayout>
                            <Switch>
                                <SentryRoute
                                    path="/project/models"
                                    exact
                                    render={() =>
                                        permissions?.model ? (
                                            <Models
                                                title={locale[lang].models}
                                            />
                                        ) : (
                                            <Redirect to="/" />
                                        )
                                    }
                                />
                                <SentryRoute
                                    path="/project/pointclouds"
                                    exact
                                    render={() =>
                                        permissions?.point_cloud ? (
                                            <Models
                                                title={locale[lang].pointClouds}
                                            />
                                        ) : (
                                            <Redirect to="/" />
                                        )
                                    }
                                />
                                <SentryRoute
                                    path="/project/panoramas"
                                    exact
                                    render={
                                        () => (
                                            // permissions?.panoramas ? (
                                            <Models
                                                title={locale[lang].panoramas}
                                            />
                                        )
                                        // ) : (
                                        //     <Redirect to="/" />
                                        // )
                                    }
                                />
                                <SentryRoute
                                    path="/viewer"
                                    render={() =>
                                        !isEmpty(currentObject) ? (
                                            <Viewer name={currentObject.name} />
                                        ) : (
                                            <Redirect to="/" />
                                        )
                                    }
                                />
                                <SentryRoute
                                    path="*"
                                    render={() => <Redirect to="/not-found" />}
                                />
                            </Switch>
                        </PrivateLayout>
                    </MainContext>
                </SentryRoute>
                <SentryRoute path={'/dashboard'}>
                    <Switch>
                        <SentryRoute
                            path="/dashboard/category"
                            render={() => (
                                <PageRedirector
                                    link={`${process.env.REACT_APP_MODELIC_REDIRECT}/b2b_user/project/${category_id}`}
                                />
                            )}
                        />
                        <SentryRoute
                            path="/dashboard/project"
                            render={() => (
                                <PageRedirector
                                    link={`${process.env.REACT_APP_MODELIC_REDIRECT}/b2b_user/project/${category_id}/${project_id}`}
                                />
                            )}
                        />
                        <SentryRoute
                            path="/dashboard"
                            render={() => (
                                <PageRedirector
                                    link={
                                        process.env.REACT_APP_MODELIC_REDIRECT
                                    }
                                />
                            )}
                        />
                    </Switch>
                </SentryRoute>
                <SentryRoute path="/not-found" component={NotFound} />
                <SentryRoute
                    path="/"
                    exact
                    render={() =>
                        permissions?.model ? (
                            <Redirect
                                to={`/project/models?viewer_token=${token}`}
                            />
                        ) : permissions?.point_cloud ? (
                            <Redirect
                                to={`/project/pointclouds?viewer_token=${token}`}
                            />
                        ) : (
                            <PageRedirector
                                link={process.env.REACT_APP_MODELIC_REDIRECT}
                            />
                        )
                    }
                />
                <SentryRoute
                    path="*"
                    render={() => <Redirect to="/not-found" />}
                />
            </Switch>
        </Router>
    );
};

export default Bimodel;
